export default __webpack_public_path__ + "static/2183-3c2acd7e0a5fe5f5b94833e57f21ac39.gif";